import IconButton from 'components/atoms/button/IconButton';
import Form from 'components/atoms/form/Form';
import Icon from 'components/atoms/icon/Icon';
import CurrencyInput from 'components/atoms/input/currency-input/CurrencyInput';
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen';
import Accordion from 'components/molecules/accordion/Accordion';
import AccordionBody from 'components/molecules/accordion/AccordionBody/AccordionBody';
import AccordionTitle from 'components/molecules/accordion/AccordionTitle/AccordionTitle';
import PrimaryDatePicker from 'components/molecules/datepicker/PrimaryDatePicker';
import { IconType } from 'lib/helpers/constants/iconTypes';
import { useUpdateCustomerProduct } from 'lib/hooks/mutations/Customers/useUpdateCustomerProduct';
import { useCustomerProduct } from 'lib/hooks/queries/Coustomer/useCustomerProduct';
import React, { FC, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';


interface Props {
    userData: any
    setCurrentUpdatePending: (value: number) => void;
}

const UpdatePendingProducts: FC<Props> = ({ userData, setCurrentUpdatePending }) => {

    const { t } = useTranslation();

    const {
        data: customerProducts,
        isLoading: fetchProductsLoading
    } = useCustomerProduct({ costumer_id: userData?.data?.costumer_id }, { enabled: true });

    const {
        handleSubmit: handleSubmitProducts,
        control: controlProducts,
        reset,
    } = useForm({
        defaultValues: {
            products: (customerProducts as any)?.data?.map?.((product: any) => ({
                id: product?.id,
                creation_date: product?.creation_date,
                company_name: product?.company_name,
                product_name: product?.product_name,
                name: product?.name,
                status: product?.status,
                last_update: product?.updated_at,
                commission: product?.commission || 0,
                commission_date: product?.commission_date,
                commission_expected: product?.commission_expected || "",
                commission_expected_difference: product?.commission_expected_difference || "",
                premium_per_month: product?.premium_per_month?.toFixed(2) || "",
                contract_end_date: product?.contract_end_date || null,
                contract_start_date: product?.contract_start_date || null,
            })),
        },
    });

    useEffect(() => {
        if ((customerProducts as any)?.data) {
            reset({
                products: (customerProducts as any).data.map((product: any) => ({
                    id: product?.id,
                    creation_date: product?.creation_date,
                    company_name: product?.company_name,
                    product_name: product?.product_name,
                    name: product?.name,
                    status: product?.status,
                    last_update: product?.updated_at,
                    commission: product?.commission || 0,
                    commission_date: product?.commission_date,
                    commission_expected: product?.commission_expected || "",
                    commission_expected_difference: product?.commission_expected_difference || "",
                    premium_per_month: product?.premium_per_month?.toFixed(2) || "",
                    contract_end_date: product?.contract_end_date || null,
                    contract_start_date: product?.contract_start_date || null,
                })),
            });
        }
    }, [customerProducts, reset]);

    const { mutateAsync: updateProduct, isLoading: updateProductLoading } = useUpdateCustomerProduct();

    const SubmitProducts = (formData: any) => {
        const updatedProducts = (customerProducts as any)?.data?.reduce(
            (acc: any, product: any, index: number) => {
                const productData = formData.products[index];

                if (productData) {
                    acc.push({
                        product_id: product.id,
                        creation_date: productData.creation_date || "",
                        company_name: productData.company_name || "",
                        product_name: productData.product_name || "",
                        name: productData.name || "",
                        status: productData.status || "",
                        last_update: productData.last_update || "",
                        commission: productData.commission || "",
                        commission_date: productData.commission_date || "",
                        premium_per_month: productData.premium_per_month || "",
                        contract_start_date: productData.contract_start_date || "",
                        contract_end_date: productData.contract_end_date || "",
                    });
                }
                return acc;
            },
            []
        );

        updateProduct({
            costumer_id: userData?.data?.costumer_id,
            products: updatedProducts,
            from_user_id: userData?.data?.from_user_id
        }).then(() => {
            setCurrentUpdatePending(1);
        })
    }


    if (fetchProductsLoading) {
        return (
            <div className="py-20 relative">

                <LoadingScreen />
            </div>
        )
    }



    return (
        <Form className="w-full" onSubmit={handleSubmitProducts(SubmitProducts)} >
            <div className='space-y-4'>

                {(customerProducts as any)?.data?.map?.((product: any, index: number) => {
                    return (

                        <Accordion
                            key={index}
                            classes={{ wrapper: "bg-white", title: "!w-full" }}
                        >

                            <AccordionTitle subTitleClass="w-full">
                                <div className="flex items-center justify-between w-full">
                                    <div className="flex items-center gap-[10px]">
                                        <Icon iconType={IconType.KVG_ICON} className="flex-none" />
                                        <span className="text-[#282D46] font-inter-medium capitalize max-w-[400px]">
                                            {product.name} {product?.product_name} (
                                            {product.company_name})
                                        </span>
                                    </div>

                                </div>
                            </AccordionTitle>
                            <AccordionBody>
                                <div className="grid grid-cols-2 w-full gap-5 pb-5">
                                    <Controller
                                        control={controlProducts}
                                        name={`products.${index}.id`}
                                        render={({ field }) => (
                                            <input
                                                type="hidden"
                                                {...field}
                                            />
                                        )}
                                    />
                                    <Controller
                                        control={controlProducts}
                                        name={`products.${index}.contract_start_date`}
                                        render={({ field: { onChange, value } }) => (
                                            <PrimaryDatePicker
                                                label={t("Contract Start Date")}
                                                startDate={value}
                                                setStartDate={(date: string) => onChange(date)}
                                            />
                                        )}
                                    />


                                    <Controller
                                        control={controlProducts}
                                        name={`products.${index}.contract_end_date`}
                                        render={({ field: { onChange, value } }) => (
                                            <PrimaryDatePicker
                                                label={t("Contract End Date")}
                                                startDate={value}
                                                setStartDate={(date: string) => onChange(date)}
                                            />
                                        )}
                                    />

                                    <Controller
                                        control={controlProducts}
                                        name={`products.${index}.premium_per_month`}
                                        render={({ field }) => (
                                            <CurrencyInput
                                                placeholder={t("Premium per month")}
                                                prefix="CHF "
                                                value={field.value || ""}
                                                onValueChange={(value) => {
                                                    field.onChange(value || "");

                                                }}
                                                label="Premium per month"
                                            />
                                        )}
                                    />
                                </div>
                            </AccordionBody>
                        </Accordion>

                    );
                })}
            </div>

            <div className="flex justify-end pt-5">
                <IconButton disabled={fetchProductsLoading || updateProductLoading}>
                    {t('Update Products')}
                </IconButton>
            </div>
        </Form>
    )
}

export default UpdatePendingProducts